import { createSlice } from '@reduxjs/toolkit'

export const MailSentReducer = createSlice({
    name: 'mailSentData',
    initialState: {
        MailSentData: null,
    },
    reducers: {
        setMailSentData: (state, action) => {
            state.MailSentData = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setMailSentData } = MailSentReducer.actions

export default MailSentReducer.reducer